
import { configureStore } from "@reduxjs/toolkit";

import viewPort from "./Slice/plateSlice";
import KirtanIndex from "./Slice/KirtanIndexSlice";
import DBConfig from "./Slice/dbSlice";
import settings from "./Slice/settingsSlice";
import FormList from "./Slice/formSlice";
import vMixButton from "./Slice/vMixButtons";
import keyboardSlice from "./Slice/keyBoardSlice";
import vMixZoomButton from "./Slice/vMixZoomSlice";

export const store = configureStore({
  reducer: {
    viewPort: viewPort,
    kirtanIndex: KirtanIndex,
    db: DBConfig,
    settings: settings,
    FormList: FormList,
    vMixButton: vMixButton,
    keyboardSlice: keyboardSlice,
    vMixZoomButton: vMixZoomButton,
  },
});
